import { Settings } from "luxon";
import moment, { utc } from "moment";
import { EMPTY_STRING } from "src/components/constant/constant";

export const getTimeZone = () => {
  const userTimeZone = Settings.defaultZone;

  return userTimeZone;
};

export const dateTimeFormat = (data: string | number | null | undefined) => {
  if (
    data === null ||
    data === undefined ||
    data === EMPTY_STRING ||
    (typeof data === "string" && data.trim() === EMPTY_STRING)
  ) {
    return {
      date: "---",
      time: "---",
      datetime: "---",
      dwml: "---",
      dateInput: "---"
    };
  }

  const formattedData =
    typeof data === "string" && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(data)
      ? data.replace(" ", "T") + "Z"
      : data;

  const DateTime = utc(formattedData).local();

  if (!DateTime.isValid()) {
    return {
      date: "---",
      time: "---",
      datetime: "---",
      dwml: "---",
      dateInput: "---"
    };
  }

  return {
    date: DateTime.format("DD/MM/YYYY"),
    time: DateTime.format("hh:mm A"),
    datetime: DateTime.format("DD/MM/YYYY hh:mm A"),
    dwml: DateTime.format("DD MMM YYYY"),
    dateInput: DateTime.format("YYYY-MM-DD")
  };
};

export const formatTimestamp = (timestamp: string | undefined): string | undefined => {
  if (timestamp && typeof timestamp === "string") {
    return timestamp.replace(" ", "T") + "Z";
  }
  return undefined;
};

export const getResetLimitDayValue = (weekday: number): { day: string; date: string } => {
  const today = moment();
  const todayWeekday = today.day();

  const targetDate = today.clone().day(weekday);

  if (weekday > todayWeekday) {
    targetDate.subtract(7, "days");
  }

  return {
    day: targetDate.date().toString(),
    date: targetDate.format("D MMM YYYY")
  };
};
